// extracted by mini-css-extract-plugin
export default {"PurchaseItemList":"PurchaseItemList_PurchaseItemList__BPMJG"};